import { render } from "./Text.vue?vue&type=template&id=54183ff6&scoped=true"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"

import "./Text.vue?vue&type=style&index=0&id=54183ff6&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54183ff6"]])

export default __exports__